module.exports = __webpack_public_path__ + "media/images/pages/ai/pocstock-ethical-ai-face-3-5685fecf7eccc2a4386b3498a0d994e0.png";